import { deleteMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const DELETE_ENTERPRISE = 'DELETE_ENTERPRISE';
export const DELETE_ENTERPRISE_SUCCESS = 'DELETE_ENTERPRISE_SUCCESS';
export const DELETE_ENTERPRISE_FAILURE = 'DELETE_ENTERPRISE_FAILURE';

// Action Creators
export const deleteEnterprise = () => ({
  type: DELETE_ENTERPRISE,
});

export const deleteEnterpriseSuccess = (data) => ({
  type: DELETE_ENTERPRISE_SUCCESS,
  payload: data,
});

export const deleteEnterpriseFailure = (error) => ({
  type: DELETE_ENTERPRISE_FAILURE,
  payload: error,
});

// Thunk Function
export const deleteEnterpriseCallAPI = (data, external) => {
  return async (dispatch) => {
    dispatch(deleteEnterprise());
    try {
      const response = await deleteMethodWithToken(
        url?.particularEnterprise + data + '/'
      );
      if (
        response?.status === 200 ||
        response?.status === 201 ||
        response?.status === 204
      ) {
        dispatch(deleteEnterpriseSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(deleteEnterpriseFailure(error?.message));
    }
  };
};
